import axios from 'axios';

export const getLifewayConsultant = async (contractId: string) =>
  axios
    .get(`${process.env.REACT_APP_LIFEWAY_API_URL}/consultant/detail-of-external-identification/${contractId}`)
    .then((response) => response.data)
    .catch((e) => console.error('Get consultant from lifeway failed', e));
